import { useEffect } from "react";

// The pages of the password recovery look like the login: the Login styles hang on html.login-page
// (hero background, card on the right), which LoginForm sets while it is mounted.
const useLoginPageClass = () => {
  useEffect(() => {
    document.documentElement.classList.add("login-page");
    return () => document.documentElement.classList.remove("login-page");
  }, []);
};

export default useLoginPageClass;
